import type * as ents from '@attain-apps/entities'
import * as graphql from '@attain-apps/fe/web/main/lib/graphql'
import * as transformers from '@attain-apps/transformers'
import { TypeAsserter } from '@attain-apps/type-guards'
import gql from 'graphql-tag'

export const DOC = gql`
  fragment FragmentDmsReferenceValueType on DmsReferenceValueType {
    dimensionId
  }
`

export const TRANSFORMER = graphql.transformers.OUT.object<
  graphql.schema.FragmentDmsReferenceValueTypeFragment,
  ents.core.dms.data.Value.Type.Reference
>({
  dimensionId: graphql.transformers.OUT.validate(
    transformers.PASS_THROUGH,
    TypeAsserter.assertIsNotNullish,
    { warnOnly: true },
  ),
  // NOTE: graphql has ability to realize that on the "union" type, we need be
  // explicit when converting into typescript, so we can identify the types in
  // the runtime
  isMultiselect: {
    usingFullInput: graphql.transformers.OUT.always(false),
  },
})
